import dispatchConfigurationService from '@/http/services/dispatch-configuration'
import store from '../../../store'
export default {
  getDispatchConfiguration ({ commit }) {
    return dispatchConfigurationService.getDispatchConfiguration(store.state.apiUrl).then((response) => {
      commit('setDispatchConfiguration', response.data)
    })
  }
}
